import React, {useState, useEffect} from "react";

import {BreadCrumbTrail} from "../../../../common/breadcrumb-trail/BreadcrumbTrail";
import topicAreaIcon from "../../../../../resources/images/topic-area-icon.png";
import {NextButton} from "../../../../common/button/next-button/NextButton";
import {BackButton} from "../../../../common/button/back-button/BackButton";
import {StandardButton} from "../../../../common/button/standard-button/StandardButton";
import {ToolTip} from "../../../../common/tool-tip/ToolTip";
import {CommentToolTip} from "../../../../common/tool-tip-comments/CommentToolTip";

export const ProblemTwo = ({
                               context,
                               showToaster,
                               setSpinnerText,
                               setContext,
                               navigateTo,
                               navigateBack,
                               toolTipsEnabled
                           }) => {

    const [outcomeMeasure, setOutcomeMeasure] = useState(null);
    const [numerator, setNumerator] = useState(null);
    const [denominator, setDenominator] = useState(null);

    useEffect(() => {
        setOutcomeMeasure(context.topicAreaScreen.indicator.outcomeMeasure);
        setNumerator(context.topicAreaScreen.indicator.numerator);
        setDenominator(context.topicAreaScreen.indicator.denominator);
        if (!context.viewMode) {
            setContext((prevState) => ({
                ...prevState,
                breadcrumbs: {
                    ...prevState.breadcrumbs,
                    problemBreadcrumb: {
                        text: prevState.problemScreen.title,
                        type: "Problem",
                        screenKey: "problemOne",
                    },
                },
            }));
        }
    }, []);

    return (
        <div className="wizard-content-container">
            <div className="wizard-main-content-container">
                <div className="wizard-left-container">
                    <div className="wizard-icon-container">
                        <img src={topicAreaIcon} alt="Aurum Logo" className="wizard-icon"/>
                    </div>
                    <p className="wizard-icon-label">{context.topicAreaScreen.topicArea.topicArea}</p>
                </div>
                <div className="wizard-right-container">
                    <div className="input-container">
                        <div>
                            <label>Outcome Measure:</label>
                            {toolTipsEnabled &&
                            <ToolTip tooltipExternalReference={"proboutcome123"}
                                     context={context}
                                     setSpinnerText={setSpinnerText} showToaster={showToaster}
                                     fieldName={"Outcome Measure:"}/>}
                        </div>
                        <input data-testid="outcome-measure-input" className="text-input" disabled={true} defaultValue={outcomeMeasure}/>
                    </div>
                    <div className="input-container">
                        <div>
                            <label>Numerator:</label>
                            {toolTipsEnabled &&
                            <ToolTip tooltipExternalReference={"probnumerator123"}
                                     context={context}
                                     setSpinnerText={setSpinnerText} showToaster={showToaster}
                                     fieldName={"Numerator:"}/>}
                        </div>
                        <input data-testid="numerator-input" className="text-input" disabled={true} defaultValue={numerator}/>
                    </div>
                    <div className="input-container">
                        <div>
                            <label>Denominator:</label>
                            {toolTipsEnabled &&
                            <ToolTip tooltipExternalReference={"probdenominator123"}
                                     context={context}
                                     setSpinnerText={setSpinnerText} showToaster={showToaster}
                                     fieldName={"Denominator:"}/>}
                        </div>
                        <input data-testid="denominator-input" className="text-input" disabled={true} defaultValue={denominator}/>
                    </div>
                    {context.viewMode &&
                    <CommentToolTip contextName={"Problem"} showToaster={showToaster} setSpinnerText={setSpinnerText}
                                    contextExternalReference={context.problemToBeViewedExternalReference}
                                    context={context} toolTipsEnabled={toolTipsEnabled}/>}
                    {context.viewMode && <div className="back-to-overview-button-container">
                        <StandardButton text="Problem Overview" onClick={() => {
                            navigateTo("problemTree");
                        }}/>
                    </div>}
                    <div className="navigation-button-container">
                        <NextButton disabled={false} onClick={() => {
                            navigateTo("problemThree")
                        }}/>
                        <BackButton onClick={navigateBack}/>
                    </div>
                </div>
            </div>

            <div className="wizard-breadcrumb-container">
                <BreadCrumbTrail context={context} navigateTo={navigateTo}/>
            </div>
        </div>
    );
}
